module.exports = __webpack_public_path__ + "img/about-icon-06.729a09f1.svg";